import { render, staticRenderFns } from "./Excel.vue?vue&type=template&id=5994fbb8&scoped=true"
import script from "./Excel.vue?vue&type=script&lang=js"
export * from "./Excel.vue?vue&type=script&lang=js"
import style0 from "./Excel.vue?vue&type=style&index=0&id=5994fbb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5994fbb8",
  null
  
)

export default component.exports